import { formatPrice } from "../../../util/utils";
import { SubStatusDtoPlanCycleEnum } from "../../../generated/account-client";

interface PriceParams {
  amount: string | number;
  cycle?: SubStatusDtoPlanCycleEnum;
  light?: boolean;
}

export default function Price({ amount, cycle, light }: PriceParams) {
  if (!amount && amount !== 0) return <></>;

  if (cycle) {
    return (
      <>{`${formatPrice(amount, light)}/${
        cycle === SubStatusDtoPlanCycleEnum.Yearly ? "year" : "month"
      }`}</>
    );
  } else {
    return <>{formatPrice(amount, light)}</>;
  }
}
